// components/ThreatTag.tsx
import { BaseTag } from '@praetorian-chariot/ui';

import type { EnrichedVulnerability } from '@/sections/threats/types';
import { DEFAULT_FORMAT_TYPE, formatDate } from '@/utils/date.util';

interface ThreatTagProps {
  vulnerability: EnrichedVulnerability | undefined;
}

/**
 * Tag displaying CVE ID with published/modified dates
 */
export function ThreatTag({ vulnerability }: ThreatTagProps) {
  if (!vulnerability) return null;

  const { id, published, modified, created, updated } = vulnerability;

  return (
    <BaseTag size="xs" className="bg-chariot-background-secondary gap-2">
      <span data-testid="cve" className="font-bold">
        {id}
      </span>
      <div className="bg-chariot-stroke h-4 w-px" />
      <div className="gap-2">
        <span className="font-bold">Published :</span>{' '}
        <span data-testid="published">
          {formatDate(published || created || '', DEFAULT_FORMAT_TYPE, false)}
        </span>
      </div>
      <div className="bg-chariot-stroke h-4 w-px" />
      <div className="gap-2">
        <span className="font-bold">Modified :</span>{' '}
        <span data-testid="modified">
          {formatDate(modified ?? updated ?? '', DEFAULT_FORMAT_TYPE, false)}
        </span>
      </div>
    </BaseTag>
  );
}
